import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {CclControlValueAccessor} from "../ccl-control-value-accessor";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {formatNumber} from "@angular/common";
import {isNumber, toFixed} from "../../ccl-util";

@Component({
    selector: 'ccl-price-input',
    template: `
        <input nz-input type="text" [(ngModel)]="value" (focus)="focus()" (blur)="blur($event)" [disabled]="disabled">
    `,
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: PriceInputComponent, multi: true}]
})
export class PriceInputComponent extends CclControlValueAccessor {
    constructor(cdr: ChangeDetectorRef) {
        super(cdr);
    }

    // ä¿çå ä½å°æ°ï¼é»è®¤2ä½
    @Input()
    fixed = 2;

    private local = 'zh';
    sourceValue: number; // åå§å¼

    // control åå¥å¼
    writeValue(value: any): void {
        if (isNumber(value)) {
            this.sourceValue = toFixed(value, this.fixed);
            this.value = formatNumber(this.sourceValue, this.local);
        } else {
            this.sourceValue = undefined;
            this.value = '';
        }

        // è¥åå¥çå¼ï¼å¨ç»è¿å°æ°ç²¾åº¦è½¬æ¢ï¼ç©ºå¼å¤æ­åï¼ä¸ä¸è´ï¼åè§¦åä¸æ¬¡ååä»¥åæ­¥å¼
        if (this.sourceValue != value) {
            this.onChange(this.sourceValue);
        }
    }

    // å½è¾å¥æ¡è·å¾ç¦ç¹æ¶ï¼å°åå§å¼æ¾ç¤ºå°è¾å¥æ¡ä¸­
    focus() {
        if (this.sourceValue && !this.readonly && !this.disabled) {
            this.value = this.sourceValue;
        }
    }

    // å½è¾å¥æ¡å¤±å»ç¦ç¹æ¶ï¼å°åé¨å¼è½¬æ¢ä¸º æ°å­åå§å¼ï¼å¹¶ä¸ä»¥ ååä½ æ¹å¼æ¾ç¤ºå°è¾å¥æ¡ä¸­
    // æ æ³è½¬æ¢ä¸ºæ°å­æ¶ï¼å°è½¬ä¸º0
    blur(e: FocusEvent) {
        if (e.currentTarget['value']) {
            const value = parseFloat(e.currentTarget['value']) || 0;
            this.sourceValue = toFixed(value, this.fixed);
            this.onChange(this.sourceValue);
            this.value = formatNumber(this.sourceValue, this.local);
        } else {
            this.sourceValue = null;
            this.value = '';
            this.onChange(null);
        }
        this.onTouched && this.onTouched();
    }
}
